import { IconButton, TableCell, TableRow } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { TimepointSubject } from '@common/config/api/client'
import SubjectStatusChip from '@features/subject/components/SubjectsTimepointsTable/SubjectStatusChip'
import QueryStatusChip from '@features/subject/components/SubjectsTimepointsTable/QueryStatusChip'

export default function SubjectTableRow({
  subject,
  expanded,
  setExpanded,
}: {
  subject: TimepointSubject
  expanded: boolean
  setExpanded: () => void
}) {
  return (
    <TableRow
      data-testid="subject-table-row"
      hover
      sx={{
        '&:hover': {
          '& > td': {
            backgroundColor: (theme) => theme.palette.action.hover,
          },
        },
      }}
    >
      <TableCell
        padding="checkbox"
        sx={{
          position: 'sticky',
          left: 0,
          bgcolor: 'background.default',
        }}
        data-testid="expand-cell"
      >
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation()
            setExpanded()
          }}
          data-testid="expand-button"
        >
          {expanded ? (
            <KeyboardArrowUpIcon data-testid="icon-expanded" />
          ) : (
            <KeyboardArrowDownIcon data-testid="icon-collapsed" />
          )}
        </IconButton>
      </TableCell>
      <TableCell
        sx={{
          position: 'sticky',
          left: 48,
          bgcolor: 'background.default',
        }}
        data-testid="pseudo-id-cell"
      >
        {subject.pseudo_id}
      </TableCell>
      <TableCell
        sx={{
          position: 'sticky',
          left: 218,
          bgcolor: 'background.default',
        }}
        data-testid="site-id-cell"
      >
        {subject.study_site_pseudo_id}
      </TableCell>
      <TableCell
        sx={{
          position: 'sticky',
          left: 388,
          bgcolor: 'background.default',
        }}
        data-testid="status-chip-cell"
      >
        <SubjectStatusChip subjectStatus={subject.status} size="small" />
      </TableCell>
      <TableCell
        sx={{
          position: 'sticky',
          left: 558,
          bgcolor: 'background.default',
        }}
        data-testid="query-chip-cell"
      >
        <QueryStatusChip queryStatus={subject.query_status as string} />
      </TableCell>
      {subject.study_timepoints?.map((studyTimepoint) => (
        <TableCell key={studyTimepoint.timepoint_id} data-testid={`timepoint-cell-${studyTimepoint.timepoint_id}`}>
          {studyTimepoint.timepoint_submissions?.length} Timepoints
        </TableCell>
      ))}
    </TableRow>
  )
}
